import PageTemplate from "@/components/templates/PageTemplate";
import { NewsItem } from "@/models/News";
import NewsPage from "@/components/support/news";
import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";
import { getAllNewsItems } from "@/Service.server";
import { GetServerSideProps } from "next";

interface Props {
  news: NewsItem[];
  categories: string[];
}

const News = ({ news, categories }: Props) => {
  return (
    <PageTemplate>
      <PageTemplate.Content>
        <NewsPage news={news} categories={categories} />
      </PageTemplate.Content>
    </PageTemplate>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const { items, categories } = getAllNewsItems();

  return {
    props: {
      news: items,
      categories,
      ...(await serverSideTranslations(locale ?? "en", ["support", "gnb"])),
    },
  };
};

export default News;
